// extracted by mini-css-extract-plugin
module.exports = {"counter":"pGDgzE","inlineMobileCounter":"M6RRSX"};